import { Skeleton } from "@mantine/core";
import React from "react";

interface Props {
  label: string;
  value: string | number;
  subLabel?: string; // e.g. "54.55%"
  bgClass?: string;
  textClass?: string;
  icon?: React.ElementType; // e.g. HiOfficeBuilding — pass the component itself, not JSX
  isLoading?: boolean;
}

export default function AttendanceStatCard({
  label,
  value,
  subLabel,
  bgClass,
  textClass,
  icon: Icon, // capitalized on destructure so JSX resolves it as a component, not a DOM tag
  isLoading,
}: Props) {
  if (isLoading) {
    return (
      <div className={`flex-1 rounded-lg p-4 border ${bgClass ?? "bg-white"}`}>
        <Skeleton height={12} width="60%" mb={10} />
        <Skeleton height={26} width="40%" />
      </div>
    );
  }
  return (
    <div className={`flex-1 rounded-lg p-4 border ${bgClass ?? "bg-white"}`}>
      <div className="text-sm text-gray-500 mt-1">{label}</div>
      <div className="flex justify-between items-center">
        <div className={`text-2xl font-bold ${textClass ?? "text-gray-800"}`}>
          {value}
        </div>
        {Icon && (
          <div className={`text-2xl ${textClass ?? "text-gray-400"}`}>
            <Icon />
          </div>
        )}
      </div>
      {subLabel && (
        <div className={`text-xs mt-1 font-medium ${textClass ?? ""}`}>
          {subLabel}
        </div>
      )}
    </div>
  );
}
